import { render, staticRenderFns } from "./DhmeManualImportObjects.vue?vue&type=template&id=b3192c96&scoped=true"
import script from "./DhmeManualImportObjects.vue?vue&type=script&lang=js"
export * from "./DhmeManualImportObjects.vue?vue&type=script&lang=js"
import style0 from "./DhmeManualImportObjects.vue?vue&type=style&index=0&id=b3192c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3192c96",
  null
  
)

export default component.exports